import { FC, ReactNode } from 'react';
import styles from './styles.module.less';
import {
  Collapse as AntdCollapse,
  CollapseProps as AntdCollapseProps,
  CollapsePanelProps as AntdCollapsePanelProps,
} from 'antd';
import clsx from 'clsx';
import { DownOutlined } from '@ant-design/icons';

interface CollapseProps extends AntdCollapseProps {
  className?: string;
}

export const Collapse: FC<CollapseProps> = ({ className, children, ...props }) => {
  return (
    <AntdCollapse
      className={clsx(styles.collapse, className)}
      expandIconPosition="right"
      expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
      {...props}
    >
      {children}
    </AntdCollapse>
  );
};

interface CollapsePanelProps extends AntdCollapsePanelProps {
  className?: string;
  key: string | number;
  header: ReactNode;
}

export const CollapsePanel: FC<CollapsePanelProps> = ({ className, key, header, children, ...props }) => {
  return (
    <AntdCollapse.Panel className={clsx(styles.panel, className)} key={key} header={header} {...props}>
      {children}
    </AntdCollapse.Panel>
  );
};
